var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { attrs: { id: "app" } },
    [
      _c("vue-toast"),
      _vm._v(" "),
      _c("loader"),
      _vm._v(" "),
      _c("header-section", { attrs: { title: _vm.login } }),
      _vm._v(" "),
      _c(
        "v-container",
        { staticStyle: { "margin-top": "140px" } },
        [
          _c(
            "transition",
            { attrs: { name: "component-fade", mode: "out-in" } },
            [_c("router-view")],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("osa-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }